module.exports = __webpack_public_path__ + "img/car-01.04103df7.svg";